import axiosInstance from './axios';

export const saleService = {
  getSales: async (params = {}) => {
    // Filter out empty string parameters
    const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
      if (value !== '' && value !== null && value !== undefined) {
        acc[key] = value;
      }
      return acc;
    }, {});

    const response = await axiosInstance.get('/sales', { params: cleanParams });
    return response.data;
  },

  getSale: async (id) => {
    const response = await axiosInstance.get(`/sales/${id}`);
    return response.data;
  },

  downloadInvoice: async (id) => {
    const response = await axiosInstance.get(`/sales/${id}/invoice`, {
      responseType: 'blob',
    });
    return response.data;
  },

  getSaleStatistics: async (params = {}) => {
    // Filter out empty string parameters
    const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
      if (value !== '' && value !== null && value !== undefined) {
        acc[key] = value;
      }
      return acc;
    }, {});

    const response = await axiosInstance.get('/sales/statistics', { params: cleanParams });
    return response.data;
  },
};
